import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PCheckboxComponent } from './p-checkbox.component';
import { PipeModule } from '@panaya/ui/pipes';

@NgModule({
    declarations: [PCheckboxComponent],
    imports: [CommonModule, PipeModule],
    exports: [PCheckboxComponent]
})
export class PCheckboxModule {}
